export default "__VITE_ASSET__379d12fb__"